<template>
  <div class="pop-in" :class="{ opened: isShown, 'scroll-popup': isScroll }">
    <div class="pop-in-content">
      <button id="popinClose" class="close" :aria-label="ariaLabel" @click="closePopIn"></button>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'popin',
  props: {
    ariaLabel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isShown: false,
      isScroll: false,
    };
  },
  mounted() {
    this.checkcookie_exist();
  },
  methods: {
    focusClose() {
      const classNames = document.getElementsByClassName('btn  btn-default');
      for (const element of classNames) {
        element.addEventListener('keydown', () => {
          document.getElementById('popinClose').focus();
        });
      }
    },
    checkcookie_exist() {
      const NewsletterCookie = this.getCookie('NewsletterCookie');
      if (NewsletterCookie) {
        this.isShown = false;
      } else {
        setTimeout(() => {
          this.isShown = true;
          this.focusClose();
        }, 5000);
      }
    },
    getCookie(name) {
      const existcookie = document.cookie
        .split(';')
        .filter((item) => item.trim().startsWith(`${name}=`)).length;
      return existcookie;
    },
    hideScroll(isHide) {
      const body = document.getElementsByTagName('body')[0];
      if (isHide) {
        body.classList.add('no-scroll');
      } else {
        body.classList.remove('no-scroll');
      }
    },
    closePopIn() {
      this.$cookies.set('NewsletterCookie', '_nc', '14d', '/; samesite=strict');
      this.hideScroll(false);
      this.isShown = false;
    },
  },
};
</script>

<style lang="scss">
$din-next-bold-condensed: 'DINNextW01-CondensedBol';

.newsletter-popin .pop-in {
  position: fixed;
  inset: 0;
  z-index: 999;
  background: rgb(0 0 0 / 70%);
  visibility: hidden;
  text-align: center;
}

.newsletter-popin .pop-in.opened {
  visibility: visible;
  opacity: 1;
  width: 100%;
}

.pop-in-content {
  max-width: 485px;
}

.pop-in .pop-in-content {
  text-align: left;
  margin: 66px auto;
  padding: 16px;
  background: #fff;
  border-radius: 4px;
  display: inline-block;
  position: relative;
}

.pop-in .pop-in-content .close {
  display: block;
  position: absolute;
  top: 10px;
  right: 12px;
  width: 30px;
  height: 30px;
  z-index: 999;
  padding: 0;
  border: 0;
  cursor: pointer;
}

.pop-in .pop-in-content .close::before,
.pop-in .pop-in-content .close::after {
  position: absolute;
  z-index: 100000;
  left: 13px;
  top: 0;
  content: ' ';
  height: 25px;
  width: 2px;
  background-color: black;
}

.pop-in .pop-in-content .close::before {
  transform: rotate(45deg);
}

.pop-in .pop-in-content .close::after {
  transform: rotate(-45deg);
}

.popin-container-content .btn-default {
  background: #242424 !important;
  color: #fff !important;
  text-transform: uppercase;
  font-size: 18px;
  font-family: $din-next-bold-condensed;
  letter-spacing: 0.3px;
  border-radius: 0;
}

.popin-container-content .btn-default:active:focus {
  background: #242424;
  color: #fff;
  text-transform: uppercase;
  font-size: 18px;
  font-family: $din-next-bold-condensed;
  letter-spacing: 0.3px;
  border-radius: 0;
}
</style>
